import { useQuery } from '@tanstack/react-query';
import { initialUiConfigDto } from '@/app/models/UiConfigDto';
import { loginAppearanceFromConfig } from './core/_utils';
import { getDetails } from './core/_requests';

const defaultAppearance = loginAppearanceFromConfig(initialUiConfigDto);

export const useLoginAppearance = () => {
  const query = useQuery({
    queryKey: ['loginAppearance'],
    queryFn: async () => {
      const response = await getDetails();
      return response.data;
    },
    retry: false,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    meta: { suppressGlobalError: true },
  });
  return { appearance: query.data ?? defaultAppearance, loading: query.isFetching };
};
